import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-param-reassign */
const filterChildren = (children, parentComponent) => {
  const withGTMChildren = [];
  const nonGTMChildren = [];
  children.forEach(child => {
    const {
      props: {
        component: {
          type = ''
        } = {}
      } = {}
    } = child;
    type === 'gtm-events' ? withGTMChildren.push(_objectSpread(_objectSpread({}, child), {}, {
      props: _objectSpread(_objectSpread({}, child.props), {}, {
        parentComponent
      })
    })) : nonGTMChildren.push(child);
  });
  return {
    withGTMChildren,
    nonGTMChildren
  };
};
const buildListChildren = (children, filteredChildren, data) => {
  const {
    props: childProps,
    props: {
      children: nestedChildren
    } = {}
  } = children;
  const childrenWithData = data ? filteredChildren.map(child => {
    child.props.component.settings.parentData = data;
    return child;
  }) : filteredChildren;
  return childrenWithData && childrenWithData.length ? _objectSpread(_objectSpread({}, children), {}, {
    props: _objectSpread(_objectSpread({}, childProps), {}, {
      children: [nestedChildren[0], childrenWithData]
    })
  }) : null;
};
const splitChildren = (children, parentData, graphqlEntityMap, parentComponent = {}) => {
  if (!children || Array.isArray(children)) return {
    regularChildren: children
  };
  const {
    props: {
      children: nestedChildren
    } = {}
  } = children;
  const {
    nonGTMChildren,
    withGTMChildren
  } = filterChildren(nestedChildren[1], parentComponent);
  const regularChildren = buildListChildren(children, nonGTMChildren);
  const parentDataWithEntity = parentData.map(item => _objectSpread(_objectSpread({}, item), {}, {
    itemId: item.id,
    itemEntity: graphqlEntityMap[item.__typename]
  }));
  const gtmChildren = buildListChildren(children, withGTMChildren, parentDataWithEntity);
  return {
    regularChildren,
    gtmChildren
  };
};
export default splitChildren;
//# sourceMappingURL=split-children.js.map